import ReactPlayer from 'react-player'
import styles from './_tourVideo.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { wistiaVideoPath } from '../../../utils/routeHelpers'
interface TourVideoProps {
  videoTitle: string
  wistiaId: string
  close: () => void
}

const TourVideo: React.FC<TourVideoProps> = ({
  videoTitle,
  wistiaId,
  close
}) => {
  return (
    <div className={styles.tourContainer}>
      <header>
        <h2 className={styles.videoTitle}>{videoTitle}</h2>
        <button className={styles.closeButton} type="button" onClick={close}>
          <FontAwesomeIcon
            icon={faTimes}
            color="#fff"
            className={styles.closeIcon}
          />
        </button>
      </header>
      <div className={styles.videoContainer}>
        <ReactPlayer
          url={wistiaVideoPath(wistiaId)}
          width={'100%'}
          height={'100%'}
        />
      </div>
    </div>
  )
}

export default TourVideo
